module.exports = __webpack_public_path__ + "img/offers-icon.3df22eb2.svg";